import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import Img from "@insite/mobius/Img";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomADIModal from "@NA/MobiusOverrides/CustomADIModal";
import { getUserDetails, isUniqueListName } from "@NA/Services/ADIXtenIntegrationService";
import ADIColors from "@NA/Utils/ADIColors";
import { spaceValidation } from "@NA/Utils/Utility";
import { text } from "express";
import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { css } from "styled-components";

// Interface for the props of ADIXtenConfirmationModal
interface ADIXtenConfirmationModalProps {
    isOpen: boolean;
    handleClose: () => void;
    actionToXten: () => void;
    isCart: boolean;
    listName: string;
    actionToXtenSignupPage: () => void;
    isUserSignedUp: boolean | null | string;
    handleCartButtonAction: (IsTemp: boolean, ListNameInput: string) => void;
}

export interface ADIXtenConfirmationModalStyles {
    buttonsWrapper?: InjectableCss;
    ADIXtenConfirmationModal?: ModalPresentationProps;
    confirmButtons?: InjectableCss;
    confirmContainer?: InjectableCss;
    learnMoreButton?: InjectableCss;
    closeContainer?: InjectableCss;
    confirmMessage?: InjectableCss;
    canclePopupButton?: ButtonPresentationProps;
    spinner?: LoadingSpinnerProps;
    h1DataWrapper?: InjectableCss;
    typographyWrapper?: InjectableCss;
    typographyWrapperContent?: InjectableCss;
    h2ContentWrapperContainer?: InjectableCss;
    paraContentWrapperContainer?: InjectableCss;
    textField?: TextFieldProps;
    errorMsg?: TypographyProps;
    textFieldContainer?: InjectableCss;
    radioButtonMainContainer?: InjectableCss;
}

// Import the ADIXtenConfirmationModalStyles object
const ADIXtenConfirmationModalStyles: ADIXtenConfirmationModalStyles = {
    ADIXtenConfirmationModal: {
        sizeVariant: "small",
    },
    confirmContainer: {
        css: css`
            &.loader-shown {
                &:before {
                    z-index: 1;
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                }
            }
            .typoWrapperMain h1 {
                font-size: 28px;
                font-weight: 700;
                line-height: 38px;
                margin-bottom: 18px;
                font-family: "Nunito Sans";
            }
        `,
    },
    radioButtonMainContainer: {
        css: css`
            margin-top: 10px;
            input#tempRadioYes {
                margin-left: 0;
                margin-right: 8px;
            }
            ,
            input#tempRadioNo {
                margin-right: 8px;
            }
            ,
            label.yesRadioContainer {
                margin-right: 12px;
                margin-top: 13px;
            }
        `,
    },
    errorMsg: {
        css: css`
            color: #c60f13;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            font-size: 16px;
            font-weight: bold;
            margin-top: 5px;
        `,
    },
    textFieldContainer: {
        css: css`
            width: 50% !important;
            input {
                margin-top: 5px;
                height: 36px;
            }
            .redBorder {
                border: 2px solid #ac1e2d !important;
            }
        `,
    },
    textField: {
        css: css`
            margin-bottom: 20px;
            [class^="FormInputWrapper-"] {
                margin-bottom: 15px;
            }
        `,
        labelProps: {
            size: 14,
            weight: "bold",
            css: css`
                color: ${getColor("text.main")};
                min-height: auto;
            `,
        },
    },

    confirmButtons: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            padding-top: 1.625rem;
            margin-top: 1.875rem;           
            justifyContent: flex-end;

            .confirmCancel {
                color: #004DA6;
                border: 1px solid #004DA6;
                border-radius: 4px;
                background-color: #ffffff;
                margin-right: 16px;
                padding: 0 20px
                &:hover{
                    color: #004DA6;
                    border: 1px solid #004DA6;
                    padding: 10px;
                    border-radius: 4px;
                    background-color: #ffffff;
                    margin-right: 10px;
                }
                span{
                    color: #004DA6;
                }
            }
            .confirmCancelHover{
                &:hover span{
                    color: #ffffff;                   
                }
            }
        `,
    },
    confirmMessage: {
        css: css`
            position: relative;
            h1 {
                color: #002554;
                font-size: 28px;
                font-weight: 700;
                line-height: 38px;
                margin-bottom: 18px;
                font-family: "Nunito Sans";
                padding-right: 20px;
                &:after {
                    height: 2px;
                    width: 44px;
                    content: "";
                    display: inline-block;
                    position: absolute;
                    bottom: -12px;
                    left: 1px;
                }
                &.h1CartMessageWrapper {
                    @media only screen and (max-width: 767px) {
                        word-wrap: break-word;
                        width: 250px;
                    }
                }
            }

            .icon-alert {
                svg {
                    transform: scale(1.5);
                    stroke: #c63527;
                }
            }
            ,
            .errorMessageContainer {
                margin-top: 5px;
            }

            p {
                color: #002554;
                font-family: Lato, sans-serif;
                font-size: 0.9375rem;
                letter-spacing: 0;
                line-height: 1.3125rem;
            }
            .spinner-container {
                position: absolute;
                text-align: center;
                margin: 0;
                z-index: 999999;
                display: block;
                left: 43%;
                top: 55%;
            }
        `,
    },
    canclePopupButton: {
        buttonType: "solid",
        css: css`
            border-radius: 2px;
            border: 2px solid #002554;
            color: #fff;
            text-transform: uppercase;
            &:hover,
            &:active {
                background-color: #002554;
                border: 2px solid #002554;
            }
            span {
                color: #fff;
            }
        `,
    },
    learnMoreButton: {
        css: css`
            // marginRight: 0 ;
            // color: #002554;
            // font-family: Roboto;
            // font-size: .9375rem;
            // letter-spacing: 0;
            // line-height: 1.3125rem;
            // text-align: center;
            // text-decoration: underline;
            // cursor: pointer;
            // margin-left: 3em;
            // margin-right: 3em;
            // justify-content: center;
            // width: auto;

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin-left: 1em;
                            margin-right: 1em;
                            min-width: 100px;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    closeContainer: {
        css: css`
            position: absolute;
            right: 1.25rem;
            top: 24px;
            .close-label {
                color: #535e64;
                font-family: Roboto;
                font-size: 0.875rem;
                letter-spacing: 0.16px;
                line-height: 1;
                display: inline-block;
                margin-right: 0.625rem;
                vertical-align: middle;
            }
            .icon-close {
                display: inline-block;
                cursor: pointer;
                vertical-align: middle;
                line-height: 1;
                width: 1.125rem;
                height: 1.125rem;
                svg {
                    height: 1.125rem;
                    width: 1.125rem;
                }
            }
        `,
    },
    typographyWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-family: "Nunito Sans";

            @media only screen and (max-width: 576px) {
                flex-direction: column;

                .paraContentWrapperContainer {
                    margin-bottom: 20px;
                }
            }
        `,
    },
    h1DataWrapper: {
        css: css`
            font-size: 28px;
            font-weight: 700;
            line-height: 38px;
            margin-bottom: 18px;
            font-family: "Nunito Sans";
        `,
    },
    typographyWrapperContent: {
        css: css`
            margin-right: 18px;

            .paraContentWrapperContainer {
                font-size: 14px;
                font-weight: 400;
                color: #2d2926;
                line-height: 20px;
                margin-top: 10px;
                font-family: "Nunito Sans";
            }
        `,
    },

    h2ContentWrapperContainer: {
        css: css`
            font-size: 18px;
            font-weight: 700;
            color: #2d2926;
            line-height: 25px;
            font-family: "Nunito Sans";
        `,
    },
};

const styles = ADIXtenConfirmationModalStyles;
const mapStateToProps = (state: ApplicationState) => ({
    location: getLocation(state),
});

type Props = ReturnType<typeof mapStateToProps> & ADIXtenConfirmationModalProps;

const ADIXtenConfirmationModal: React.FC<Props> = ({
    isOpen,
    handleClose,
    actionToXten,
    isCart,
    listName,
    location,
    actionToXtenSignupPage,
    isUserSignedUp,
    handleCartButtonAction,
}) => {
    const [IsTemp, setIsTemp] = useState(false);
    const [noChecked, setNoChecked] = useState(true);
    const [ListNameInput, setListNameInput] = useState("");
    const [redBorder, setRedBorder] = useState("noRedBorder");
    const [newListNameError, setNewListNameError] = useState<React.ReactNode>("");

    const newListInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const trimmedValue = spaceValidation(event.target.value);
        setListNameInput(trimmedValue);
        if (event.target.value) {
            setNewListNameError("");
            setRedBorder("noRedBorder");
        }
    };

    const handleNoChange = () => {
        if (!noChecked) {
            setNewListNameError("");
            setRedBorder("noRedBorder");
            setNoChecked(true);
            setIsTemp(false);
        }
    };

    const handleYesChange = () => {
        setNewListNameError("");
        setRedBorder("noRedBorder");
        setNoChecked(false);
        setIsTemp(!IsTemp);
    };
    const handleCartButtonActionLocal = async () => {
        setNewListNameError("");
        setRedBorder("noRedBorder");
        if (ListNameInput === "" && IsTemp) {
            setRedBorder("redBorder");
            setNewListNameError(translate("Please enter list name"));
            return;
        }
        if (noChecked === false) {
            const isListExist = await isUniqueListName(ListNameInput);
            if (isListExist) {
                setRedBorder("redBorder");
                setNewListNameError(translate("List name already exists"));
                return;
            } else {
                handleCartButtonAction(!IsTemp, ListNameInput);
            }
        } else {
            handleCartButtonAction(!IsTemp, ListNameInput);
        }
    };

    return (
        <CustomADIModal
            isOpen={isOpen}
            data-test-selector="ADIXtenConfirmationModal"
            {...styles.ADIXtenConfirmationModal}
            handleClose={handleClose}
            className="confirm-remove-modal"
        >
            {isCart && isUserSignedUp ? (
                <Typography as="div" {...styles.confirmContainer}>
                    <Typography as="div" {...styles.confirmMessage}>
                        <Typography>
                            {" "}
                            <h1 className="h1CartMessageWrapper">{translate("Cart Export to XTEN-AV")}</h1>
                        </Typography>
                        {translate(
                            `The contents of your cart will be exported to XTEN-AV, do you want to save these cart items to a list?`,
                        )}
                        <Typography {...styles.radioButtonMainContainer} as="div">
                            <Typography className="yesRadioContainer" as="label" htmlFor="tempRadioYes">
                                <span>
                                    <input type="radio" id="tempRadioYes" checked={IsTemp} onChange={handleYesChange} />
                                </span>
                                <span>{translate("Yes, save cart to list.")}</span>
                            </Typography>
                            <Typography className="noRadioContainer" as="label" htmlFor="tempRadioNo">
                                <span>
                                    <input
                                        type="radio"
                                        value="no"
                                        checked={noChecked}
                                        id="tempRadioNo"
                                        onChange={handleNoChange}
                                    />
                                </span>
                                <span>{translate("No, do not save to list.")}</span>
                            </Typography>
                        </Typography>
                        {IsTemp && (
                            <Typography {...styles.textFieldContainer}>
                                <TextField
                                    value={ListNameInput}
                                    onChange={newListInputChangeHandler}
                                    maxLength={12}
                                    className={redBorder}
                                    placeholder="Please enter your custom list name"
                                />
                            </Typography>
                        )}
                        {newListNameError && (
                            <Typography {...styles.errorMsg} as="div">
                                {newListNameError}
                            </Typography>
                        )}
                    </Typography>
                    <Typography as="div" {...styles.confirmButtons}>
                        <Button onClick={handleClose} className="confirmCancel confirmCancelHover">
                            {translate("Cancel")}
                        </Button>
                        <Button onClick={handleCartButtonActionLocal}>{translate("Continue")}</Button>
                    </Typography>
                </Typography>
            ) : isCart && !isUserSignedUp && location?.pathname?.toLocaleLowerCase() !== "/cart" ? (
                <Typography as="div" {...styles.confirmContainer}>
                    <Typography as="div" {...styles.confirmMessage}>
                        <Typography>
                            {" "}
                            <h1 className="h1CartMessageWrapper">{translate("Cart Export to XTEN-AV")}</h1>
                        </Typography>
                        {translate(
                            `The contents of your cart will be exported to XTEN-AV, do you want to save these cart items to a list?`,
                        )}
                        <Typography {...styles.radioButtonMainContainer} as="div">
                            <Typography className="yesRadioContainer" as="label" htmlFor="tempRadioYes">
                                <span>
                                    <input type="radio" id="tempRadioYes" checked={IsTemp} onChange={handleYesChange} />
                                </span>
                                <span>{translate("Yes, save cart to list.")}</span>
                            </Typography>
                            <Typography className="noRadioContainer" as="label" htmlFor="tempRadioNo">
                                <span>
                                    <input
                                        type="radio"
                                        value="no"
                                        checked={noChecked}
                                        id="tempRadioNo"
                                        onChange={handleNoChange}
                                    />
                                </span>
                                <span>{translate("No, do not save to list.")}</span>
                            </Typography>
                        </Typography>
                        {IsTemp && (
                            <Typography {...styles.textFieldContainer}>
                                <TextField
                                    value={ListNameInput}
                                    onChange={newListInputChangeHandler}
                                    maxLength={12}
                                    className={redBorder}
                                    placeholder="Please enter your custom list name"
                                />
                            </Typography>
                        )}
                        {newListNameError && (
                            <Typography {...styles.errorMsg} as="div">
                                {newListNameError}
                            </Typography>
                        )}
                    </Typography>
                    <Typography as="div" {...styles.confirmButtons}>
                        <Button onClick={handleClose} className="confirmCancel confirmCancelHover">
                            {translate("Cancel")}
                        </Button>
                        <Button onClick={handleCartButtonActionLocal}>{translate("Continue")}</Button>
                    </Typography>
                </Typography>
            ) : (
                <Typography as="div" {...styles.confirmContainer} className="typoWrapperMain">
                    <Typography as="div" {...styles.confirmMessage}>
                        <h1 {...styles.h1DataWrapper}>{translate("Sign up for Free Trial for X-TEN AV")}</h1>
                        <Typography {...styles.typographyWrapper} as="div">
                            <Typography as="div" {...styles.typographyWrapperContent}>
                                <h2 {...styles.h2ContentWrapperContainer}>
                                    <b>{translate("Create amazing project designs & winning proposals")}</b>
                                </h2>
                                <p className="paraContentWrapperContainer">
                                    {" "}
                                    {translate(
                                        "Join 12,000+ AV integrators, AV designers,manufacturers & end users that trust XTEN - AV to streamline their AV designs, proposals and collaborate online!",
                                    )}
                                </p>
                            </Typography>
                            <p>
                                <Img
                                    altText="Template Image"
                                    src="/userfiles/xten-av-proposals.png"
                                    style={{ width: "267px" }}
                                />
                            </p>
                        </Typography>
                    </Typography>
                    <Typography as="div" {...styles.confirmButtons}>
                        <Button onClick={handleClose} className="confirmCancel confirmCancelHover">
                            {translate("Cancel")}
                        </Button>
                        <Button onClick={actionToXtenSignupPage} {...styles.learnMoreButton}>
                            {translate("Learn More")}
                        </Button>
                    </Typography>
                </Typography>
            )}
        </CustomADIModal>
    );
};

export default connect(mapStateToProps)(ADIXtenConfirmationModal);
